@use "sass:color";
@import "../../colors.scss";

.wheel {
  height: calc(($ARTICLE_WIDTH) / 2 - 2rem);
  width: calc(($ARTICLE_WIDTH) / 2 - 2rem);
  margin: 2rem;
  border-radius: 100%;
  background-color: $ACCENT_ALT;
  box-shadow: $BOX_SHADOW;
  font-family: $MONOSPACE_FONT;
  overflow: visible;

  transition: background-color 0.1s;

  &.hover {
    background-color: color.adjust($ACCENT_ALT, $alpha: -0.3);
  }
}

.segmentGroup {
  transition: transform 0.4s;

  .segment {
    opacity: 0.2;
    transition: opacity 0.1s;
  }

  &.hover,
  &.highlighted {
    .segment {
      opacity: 1;
    }
  }
}

.link {
  pointer-events: none;
  opacity: 0.3;
  transition: opacity 0.1s, stroke-width 0.1s, transform 0.4s;
  stroke-width: 1px;

  &.hover,
  &.highlighted {
    opacity: 1;
    stroke-width: 3px;
  }

  &.highlighted {
    @keyframes dash {
      from {
        stroke-dashoffset: 200;
      }
      to {
        stroke-dashoffset: 0;
      }
    }

    stroke-dasharray: 20;
    animation: dash 1.5s linear infinite;
  }
}

.outerLabel {
  transition: color 0.1s, font-size 0.1s;
  &.highlighted {
    color: green;
    font-size: 1.5rem;
  }
  &.highlightedOutput {
    color: red;
    font-size: 1.5rem;
  }
}

.wheelLabel {
  opacity: 0.5;
  transition: transform 0.4s;
  pointer-events: none;
}
